module.exports = __webpack_public_path__ + "img/getGiftTicket_example.08099fdc.png";